exports.install = function (Vue,options) {
	
	//是否登录
	Vue.prototype.isLogin = function () {
		let login = localStorage.getItem('userInfo');
		console.log(login);
		if(login){
			login = JSON.parse(login);		
			if (login.id) {
				return login;
			} else {
				return {};
			}
		}else{
			return {};
		}
	}
}


// WEBPACK FOOTER //
// ./src/function.js